angular.module('rentalListingModule').component('rentalListingAbandonedMessage', {
	templateUrl: 'rentalListingAbandonedMessage/rentalListingAbandonedMessage.html',
	bindings: {
		to: '<',
		listing: '<',
		imageSrc: '<',
		isMobile: '<',
		myListingUrl: '<',
		onClickNext: '&',
		onClearForm: '&',
		onClosePopup: '&',
		onContinuePopup: '&',
		prevStep: '<',
		steps: '<'
	},
	controller: ['$http', 'PubSub', function($http, PubSub) {
		this.clickNext = function() {
			this.onClickNext({to: this.to});
			this.onContinuePopup();
		};

		this.close = function() {
			this.onClosePopup();
		}
	}]
});
